import { Component, OnInit } from '@angular/core';
import { CartBill, CartFees } from '@cargos/sprintpay-models';
import { Breadcrumbs } from 'src/app/shared/components';
import { BreadcrumbsService } from 'src/app/shared/components/breadcrumbs/services/breadcrumbs.service';
import { SearchType } from 'src/app/shared/models/search-type';
import { AwbSplitByFlightService } from 'src/app/shared/modules/cart/cart-items/awb-split-by-flight/services/awb-split-by-flight.service';
import { FeesConfiguration } from 'src/app/shared/modules/cart/lib-cart/shared/models/convenience-fee.enum';
import { AwbLookUpService, SummaryService } from 'src/app/shared/services';
import { SearchByFlightService } from 'src/app/shared/services/search-by-flight.service';

@Component({
    selector: 'app-cart-alliance',
    templateUrl: './cart.component.html',
    styleUrls: ['./cart.component.scss'],
    standalone: false,
})
export class CartAllianceComponent implements OnInit {
    public customSubtotal = true;
    public customSubtotalTitle = 'Charge & Fees subtotal';
    public titleCustomFees = 'AGI Convenience Fee';
    public searchType: string | null = null;
    public cartNote =
        'Please note: Payments made in error will need to be reviewed by AGI Cargo for final  approval.  This refund approval process can take up to 14 business days.  If you suspect a refund is due please email payments@agi.aero for assistance.';
    public convenienceFees: FeesConfiguration[] = [
        {
            feeName: CartFees.ISC_FEE,
            feeLabel: CartBill.getFeeDescription(CartFees.ISC_FEE),
            feeValue: 0,
        },
        {
            feeName: CartFees.STATION_FEES,
            feeLabel: '',
            feeValue: 0,
            getFeeInfoTooltip: (feeLabel) => {
                const labelDescription = feeLabel?.toLowerCase().includes('qsp') ? 'qsp' : feeLabel;

                switch (labelDescription) {
                    case 'qsp':
                        return 'QSP Fee is only applicable to SFO648 Building Airport. Fee is collected for SFO Quality Standards Program';
                    default:
                        return '';
                }
            },
        },
        {
            feeName: CartFees.NON_ISC_FEE,
            feeLabel: CartBill.getFeeDescription(CartFees.NON_ISC_FEE),
            feeValue: 0,
        },
        {
            feeName: CartFees.NON_RESERVATION_FEE,
            feeLabel: CartBill.getFeeDescription(CartFees.NON_RESERVATION_FEE),
            feeValue: 0,
            getFeeInfoTooltipHTML: (feeLabel) => {
                switch (feeLabel) {
                    case CartBill.getFeeDescription(CartFees.NON_RESERVATION_FEE):
                        return 'Front Counter Service Fee of $8.00 per MAWB will be assessed initially on all transactions. For every successful “Skip The Front Counter Transaction” a promo code of an equal amount will be provided by email and can be applied to a future transaction. To learn more about Skip the Front Counter <a href="https://firebasestorage.googleapis.com/v0/b/alliance-org-dce64.appspot.com/o/AGI%20SprintPass%20Skip%20the%20Front%20Counter%20for%20the%20Cargo%20Community.pdf?alt=media&token=952d4288-9fcd-4e5e-a33b-f79764caaf82" target="_blank" id="tooltipFeeLink"> click here </a>';
                    default:
                        return '';
                }
            },
        },
        {
            feeName: CartFees.CREDIT_CARD_FEE_TOTAL,
            feeLabel: CartBill.getFeeDescription(CartFees.CREDIT_CARD_FEE_TOTAL),
            feeValue: 0,
            extraFee: true,
        },
        {
            feeName: CartFees.HANDLING_FEE_TOTAL,
            feeLabel: CartBill.getFeeDescription(CartFees.HANDLING_FEE_TOTAL),
            feeValue: 0,
            extraFee: true,
        },
        {
            feeName: CartFees.TSF_FUEL_SURCHARGE_FEE,
            feeLabel: CartBill.getFeeDescription(CartFees.TSF_FUEL_SURCHARGE_FEE),
            feeValue: 0,
            getFeeInfoTooltipHTML: (feeLabel) => {
                switch (feeLabel) {
                    case CartBill.getFeeDescription(CartFees.TSF_FUEL_SURCHARGE_FEE):
                        return 'A fuel surcharge will be added to each transaction.';
                    default:
                        return '';
                }
            },
        },
    ];

    public convenienceFeesByPaymentRequest: FeesConfiguration[] = [
        {
            feeName: CartFees.CUSTOMS_FEE,
            feeLabel: '',
            feeValue: 0,
            getFeeInfoTooltip: (feeLabel) => {
                let labelDescription = feeLabel;

                if (feeLabel?.toLowerCase().includes(CartBill.getFeeDescription(CartFees.EWR_FEE).toLowerCase())) {
                    labelDescription = CartBill.getFeeDescription(CartFees.EWR_FEE);
                    this.convenienceFeesByPaymentRequest[0].feeLabel = feeLabel;
                }

                return '';
            },
        },
        {
            feeName: CartFees.HANDLING_FEE,
            feeLabel: CartBill.getFeeDescription(CartFees.HANDLING_FEE),
            feeValue: 0,
        },
        {
            feeName: CartFees.CREDIT_CARD_FEE,
            feeLabel: CartBill.getFeeDescription(CartFees.CREDIT_CARD_FEE),
            feeValue: 0,
            extraFee: true,
        },
        {
            feeName: CartFees.TSF_FUEL_SURCHARGE_FEE,
            feeLabel: CartBill.getFeeDescription(CartFees.TSF_FUEL_SURCHARGE_FEE),
            feeValue: 0,
            getFeeInfoTooltipHTML: (feeLabel) => {
                switch (feeLabel) {
                    case CartBill.getFeeDescription(CartFees.TSF_FUEL_SURCHARGE_FEE):
                        return 'A fuel surcharge will be added to each transaction.';
                    default:
                        return '';
                }
            },
        },
    ];

    public convenienceFeesByAWB: FeesConfiguration[] = [
        {
            feeName: 'convenienceFeeAwb',
            feeLabel: 'AGI ' + CartBill.getFeeDescription(CartFees.CONVENIENCE_FEE),
            feeValue: 0,
        },
        {
            feeName: 'nonReservationFeeAwb',
            feeLabel: CartBill.getFeeDescription(CartFees.NON_RESERVATION_FEE),
            feeValue: 0,
            extraFee: true,
        },
        {
            feeName: CartFees.TSF_FUEL_SURCHARGE_FEE_AWB,
            feeLabel: CartBill.getFeeDescription(CartFees.TSF_FUEL_SURCHARGE_FEE_AWB),
            feeValue: 0,
            getFeeInfoTooltipHTML: (feeLabel) => {
                switch (feeLabel) {
                    case CartBill.getFeeDescription(CartFees.TSF_FUEL_SURCHARGE_FEE):
                        return 'A fuel surcharge will be added to each transaction.';
                    default:
                        return '';
                }
            },
        },
    ];

    constructor(
        private breadcrumbsService: BreadcrumbsService,
        private summaryService: SummaryService,
        private awbLookUpService: AwbLookUpService,
        private searchByFlightService: SearchByFlightService,
        private awbByFlightService: AwbSplitByFlightService
    ) {}

    ngOnInit(): void {
        this.searchType = this.summaryService.getSearchType();
        this.updateBreadcrumbs();
        this.setFeesByPaymentRequest();
        this.setFeesByAWB();
    }

    updateBreadcrumbs(): void {
        const breadcrumbs = this.getBreadcrumbs();

        this.breadcrumbsService.sendMessage(breadcrumbs);
    }

    getBreadcrumbs(): Breadcrumbs[] {
        const chargeBreadcrumb = this.validateCharges();
        const breadcrumb = [{ section: 'HOME', link: '/', class: '' }];

        if (chargeBreadcrumb) {
            breadcrumb.push(chargeBreadcrumb);
        }
        breadcrumb.push({
            section: 'CART',
            link: '/cart',
            class: 'active',
        });
        return breadcrumb;
    }

    validateCharges(): null | {
        section: string;
        link: string;
        class: string;
    } {
        const isPayment = this.isValidPayment();

        if (!isPayment) {
            return null;
        }
        if (this.searchType === SearchType.awb) {
            return {
                section: 'CHARGES',
                link: '/search-awb/details/charges',
                class: '',
            };
        }
        return {
            section: 'CHARGES',
            link: '/search-flight/details/flight',
            class: '',
        };
    }

    isValidPayment(): boolean {
        if (this.searchType === SearchType.awb) {
            return !!this.awbLookUpService.instant_current_payment;
        }
        return !!this.searchByFlightService.instant_current_payment;
    }

    setFeesByPaymentRequest(): void {
        this.awbByFlightService.setConvenienceFeesByRequest(this.convenienceFeesByPaymentRequest);
    }

    setFeesByAWB(): void {
        this.awbByFlightService.setConvenienceFeesByAWB(this.convenienceFeesByAWB);
    }
}
